(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.accountProjects', {
                    requireLogin: true,
                    url: 'admin/accountProjects/:account_id',
                    templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/accountProjects/accountProjects.html?app_v=deployDate',
                    controller: 'accountProjectsCtrl',
                    scope: {},
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'accountProjects']
                    },
                    params: {
                        account_id: null
                    }
                });
        }]);
})();